<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <div class="d-flex justify-center">
          <v-subheader class="headline font-weight-bold ">Operations Audits</v-subheader>
        </div>
      </v-col>

      <v-col v-if="modules.AllOpsAudit" cols="12" sm="6" md="6" lg="4">
        <router-link :to="{ name: 'generalAudits', params: { type: 'All' } }">
          <clickable-card gotoIcon="mdi-arrow-top-right" icon="mdi-file-document-edit-outline"
            color="orange" cardTitle="All Ops Audits"> </clickable-card>
        </router-link>
      </v-col>

      <v-col v-if="modules.AuditDraftList" cols="12" sm="6" md="6" lg="4">
        <router-link :to="{ name: 'generalAuditDraftList' }">
          <clickable-card gotoIcon="mdi-arrow-top-right" icon="mdi-content-save-all-outline"
            color="orange" cardTitle="View Drafts"> </clickable-card>
        </router-link>
      </v-col>

      <v-col v-if="modules.AuditClosedList" cols="12" sm="6" md="4" lg="4">
        <router-link :to="{ name: 'auditClosures' }">
          <clickable-card gotoIcon="mdi-arrow-top-right" icon="mdi-scoreboard" color="orange"
            cardTitle="Audit Closures"> </clickable-card>
        </router-link>
      </v-col>
      <v-col v-if="modules.AuditCategoryAdd" cols="12" sm="6" md="6" lg="4">
        <router-link :to="{ name: 'generallistAuditCategory' }">
          <clickable-card gotoIcon="mdi-arrow-top-right" icon="mdi-sign-text" color="orange"
            cardTitle="Add Categories and Subcategories"> </clickable-card>
        </router-link>
      </v-col>
      <v-col v-if="modules.AuditResponseAdd" cols="12" sm="6" md="6" lg="4">
        <router-link :to="{ name: 'addResponseType' }">
          <clickable-card gotoIcon="mdi-arrow-top-right" icon="mdi-sign-text" color="orange"
            cardTitle="Add Response"> </clickable-card>
        </router-link>
      </v-col>
      <v-col v-if="modules.AuditReportListing" cols="12" sm="6" md="6" lg="4">
        <router-link :to="{ name: 'auditReportListing' }">
          <clickable-card gotoIcon="mdi-arrow-top-right" icon="mdi-file-document-edit-outline"
            color="orange" cardTitle="Audit Report List"> </clickable-card>
        </router-link>
      </v-col>
       <v-col v-if="modules.AddAuditType" cols="12" sm="6" md="6" lg="4">
        <router-link :to="{ name: 'auditTypeList' }">
          <clickable-card gotoIcon="mdi-arrow-top-right" icon="mdi-file-document-edit-outline"
            color="orange" cardTitle="Add Audit Type"> </clickable-card>
        </router-link>
      </v-col>

    </v-row>
  </v-container>
</template>
<script>
import Utils from '@/utils'
import ClickableCard from '@/components/template/ClickableCard'

export default {
  name: 'auditMaster',
  components: { ClickableCard },
  data () {
    return {
      modules: {
        AllOpsAudit: this.checkModuleAccess('AllOpsAudit'),
        AuditReportListing: this.checkModuleAccess('AuditReportListing'),
        AuditDraftList: this.checkModuleAccess('AuditDraftList'),
        AuditCategoryAdd: this.checkModuleAccess('AuditCategoryAdd'),
        AuditClosedList: this.checkModuleAccess('AuditClosedList'),
        AuditResponseAdd: this.checkModuleAccess('AuditResponseAdd'),
        AddAuditType: this.checkModuleAccess('AddAuditType')
      }
    }
  },
  methods: {
    checkModuleAccess: function (moduleName) {
      return Utils.helper.checkAccessByModule(this.$route, moduleName)
    }
  },
  async created () {
    console.log(this.modules)
  }
}
</script>
<style scoped>
.v-card {
  padding-bottom: 15px;
}
</style>
